const OnePacific = {
  name: "One Pacific",
  location: "Hong-Kong, HK",
  position: "Data Analyst",
  date: "05/2019 - 08/2019",
  icon: <i class="fa-solid fa-database"></i>,
  tools: ["JavaScript", "NetSuite", "OpenAir", "Java", "SQL", "Excel"],
  style: "work work--4",
};

const LifePod = {
  name: "Lifepod Solutions",
  location: "Boston, MA",
  position: "Quality Assurance Engineer",
  date: "01/2021 - 05/2021",
  icon: <i class="fa-solid fa-vial-virus"></i>,
  tools: ["Java", "Selenium", "Jenkins", "Jira (Agile)", "AWS", "HTML"],
  style: "work work--3",
};

const DCity = {
  name: "DCity Bank",
  location: "Dushanbe, TJ",
  position: "Software Engineer",
  date: "08/2021 - 01/2022",
  icon: <i class="fa-solid fa-mobile-screen-button"></i>,
  tools: [
    "React Native",
    "React JS",
    "JavaScript",
    "Firebase",
    "Figma (UI/UX)",
    "Redux",
  ],
  style: "work work--2",
};

const Brainnest = {
  name: "Brainnest",
  location: "Bremen, GR",
  position: "Front-End Developer",
  date: "01/2023 - 04/2023",
  icon: <i class="fa-solid fa-laptop-code"></i>,
  tools: ["JavaScript", "HTML", "CSS", "REST API", "Selenium", "UI/UX"],
  style: "work work--1",
};

export const workData = [Brainnest, DCity, LifePod, OnePacific];
